import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/checkmarkSmall.tsx
var CheckmarkSmall = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M6.5 13.1592L10.3464 16.2501L17.5 7.75012",
		stroke: "currentColor",
		strokeWidth: "1.69096",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M6.5 13.1592L10.3464 16.2501L17.5 7.75012",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { CheckmarkSmall };
